export default __webpack_public_path__ + "images/gaugechart.eabfbc2ec4f32a05be2cb5a9919411b5.svg";